import { handleResponse, handleError } from "./apiUtils";
import { saveAs } from "file-saver";
const baseUrl = "/api/GK/";
const authHeaders = () =>
  new Headers({
    Authorization:
      "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
  });

//Data import
async function postGkImport(formData, overwrite = {}) {
  const url = baseUrl + (overwrite ? "ImportList/UploadToDatabase" : "ImportList");

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: authHeaders(),
      body: formData,
    });

    const statusCode = response.status;

    if (statusCode === 401) {
      sessionStorage.removeItem("token");
      return { statusCode: 401, ok: false, data: null };
    }

    let text = null;
    try {
      text = await response.text();
    } catch {
      text = null;
    }

    let data = null;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        // not JSON � leave data as null
      }
    }

    return {
      statusCode,
      ok: response.ok,
      data,
    };
  } catch (error) {
    console.error("API call failed. " + error);
    return null;
  }
}

// Normal import
export function gkImport(files) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("file", files[i]);
  }

  return postGkImport(formData, false );
}

export function gkImportFromText(text) {
  const formData = new FormData();
  const blob = new Blob([text], { type: "text/plain" });
  formData.append("file", blob, "gk-corrected.txt");

  return postGkImport(formData, false );
}

export function gkConfirmImport(files) {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("file", files[i]);
  }

  return postGkImport(formData, true );
}

export function gkConfirmImportFromText(text) {
  const formData = new FormData();
  const blob = new Blob([text], { type: "text/plain" });
  formData.append("file", blob, "gk-corrected.txt");

  return postGkImport(formData, true );
}

export function getImportListCompanies(year, quarter) {
  return fetch(
    baseUrl + "ImportList/Companies?year=" + year + "&quarter=" + quarter,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function getImportList(companyId, year, quarter) {
  return fetch(
    baseUrl +
    "ImportList?companyId=" +
    companyId +
    "&year=" +
    year +
    "&quarter=" +
    quarter,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function deleteimportdata(companyId, year, quarter) {
  return fetch(
    baseUrl +
    "ImportList?companyId=" +
    companyId +
    "&year=" +
    year +
    "&quarter=" +
    quarter,
    {
      method: "DELETE",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response;
      } else {
        return false;
      }
      // if (response.status === 400) {
      //   // So, a server-side validation error occurred.
      //   // Server side validation returns a string error message, so parse as text instead of json.
      //   const error = await response.text();
      //   throw new Error(error);
      // }
      // throw new Error("Network response was not ok.");
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

export function getYears() {
  return fetch(baseUrl + "Vintages", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getQuarters(year) {
  return fetch(baseUrl + "Quarters?year=" + year, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getExcelFileQuarters(year, download) {
  return fetch(baseUrl + "Quarters?year=" + year + "&export=" + download, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "Content-Type/attachment",
    }),
    responseType: "blob",
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.status === 404) {
        return false;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getCountries(fromYear, fromQuarter, toYear, toQuarter) {
  return fetch(
    baseUrl +
    "Countries?fromYear=" +
    fromYear +
    "&fromQ=" +
    fromQuarter +
    "&toYear=" +
    toYear +
    "&toQ=" +
    toQuarter,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    }
  )
    .then(handleResponse)
    .catch(handleError);
}

export function getExcelFileCountries(
  fromYear,
  fromQuarter,
  toYear,
  toQuarter,
  download
) {
  return fetch(
    baseUrl +
    "Countries?fromYear=" +
    fromYear +
    "&fromQ=" +
    fromQuarter +
    "&toYear=" +
    toYear +
    "&toQ=" +
    toQuarter +
    "&export=" +
    download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.status === 404) {
        return false;
      } else {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}
